/**
 * Položka na výběr v datumovém filtru na mapě.
 */
export enum DateFilterItem {
    /**
     * Odpovídá {@link SymbolicDate.TODAY}.
     */
    TODAY = 'TODAY',

    /**
     * Odpovídá {@link SymbolicDate.TODAY_PLUS_WEEK}.
     */
    TODAY_PLUS_WEEK = 'TODAY_PLUS_WEEK',

    /**
     * Odpovídá {@link SymbolicDate.TODAY_PLUS_TWO_WEEKS}.
     */
    TODAY_PLUS_TWO_WEEKS = 'TODAY_PLUS_TWO_WEEKS',

    /**
     * Odpovídá {@link SymbolicDate.TODAY_PLUS_MONTH}.
     */
    TODAY_PLUS_MONTH = 'TODAY_PLUS_MONTH',

    /**
     * Odpovídá {@link SymbolicDate.TODAY_AND_FUTURE}.
     */
    TODAY_AND_FUTURE = 'TODAY_AND_FUTURE',

    /**
     * Odpovídá {@link SymbolicDate.TODAY_PLUS_MINUS_WEEK}.
     */
    TODAY_PLUS_MINUS_WEEK = 'TODAY_PLUS_MINUS_WEEK',

    /**
     * Odpovídá {@link SymbolicDate.THIS_WEEK}.
     */
    THIS_WEEK = 'THIS_WEEK',

    /**
     * Odpovídá {@link SymbolicDate.THIS_MONTH}.
     */
    THIS_MONTH = 'THIS_MONTH',

    /**
     * Odpovídá {@link SymbolicDate.THIS_YEAR}.
     */
    THIS_YEAR = 'THIS_YEAR',

    /**
     * Odpovídá {@link SymbolicDate.NEXT_WEEK}.
     */
    NEXT_WEEK = 'NEXT_WEEK',

    /**
     * Odpovídá {@link SymbolicDate.NEXT_MONTH}.
     */
    NEXT_MONTH = 'NEXT_MONTH',

    /**
     * Odpovídá {@link SymbolicDate.NEXT_YEAR}.
     */
    NEXT_YEAR = 'NEXT_YEAR',

    /**
     * Neomezený rozsah.
     */
    UNLIMITED = 'UNLIMITED',

    /**
     * Umožní uživateli zadat libovolné datum.
     */
    CUSTOM_DATE = 'CUSTOM_DATE',

    /**
     * Umožní uživateli zadat libovolné počáteční a koncové datum.
     */
    CUSTOM_RANGE = 'CUSTOM_RANGE',
}
